import { Descriptions, Tag } from "antd";
import React from "react";

const ClaimStatusTag = ({ status }: { status: string }) => {
  const statusTagColors: Record<string, string> = {
    CREATED: "processing",
    APPROVED: "success",
    REJECTED: "error",
  };

  return <Tag color={statusTagColors[status] ?? "default"}>{status}</Tag>;
};

export default ClaimStatusTag